var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"pageName":_vm.pageName}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column"},[_c('Tenant',{attrs:{"tenants":_vm.tenantList},on:{"tenant-added":_vm.addTenant}})],1),_c('div',{staticClass:"column"},[_c('User',{attrs:{"users":_vm.userList},on:{"user-added":_vm.addUser}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }